<template>
  <section class="module-video sg-space">
    <headlineCategory
      v-if="showMoreTitle"
      :headlineTitle="headlineTitle"
      :headline-more-title="showMoreTitle?.title"
      :url="showMoreTitle?.url"
      :routing-data="showMoreTitle?.routing_data"
      :type="showMoreTitle?.type"
      :is-app-link="showMoreTitle ? true : false"
      :headlineHomePage="true"
    />
    <headline v-else :headlineTitle="headlineTitle" />
    <div class="module-video__container">
      <div class="container">
        <div class="columns is-multiline">
          <div class="column">
            <div class="module-video__player">
              <module-player
                v-if="showMediaPlayer"
                :videoId="currentVideo?._id"
                :videoImage="currentVideo?.image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="module-video__slider">
      <div class="container module-video__slider-container">
        <div class="module-video__content">
          <Carousel class="columns" :breakpoints="breakpoints">
            <slide
              v-for="(slide, index) in context.items"
              :key="index"
              @click="selectItems(slide, index)"
              class="column is-3-desktop is-3-tablet is-6-mobile"
            >
              <div class="module-video__item">
                <photo-loader
                  :image="slide.image"
                  height-skeletor="167"
                  :imgWidth="296"
                  :imgHeight="168"
                />
                <div class="module-video__tag" v-if="currentTag === index">{{ tag }}</div>
              </div>
              <div class="module-video__description">
                {{ getArticleTitle(slide) }}
              </div>
            </slide>
            <template #addons>
              <navigation />
            </template>
          </Carousel>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed, watch, onMounted, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useSectionsStore } from '@/stores/section'
import { Carousel, Slide, Navigation } from 'vue3-carousel'

import Headline from '@/components/elements/headline.vue'
import HeadlineCategory from '@/components/elements/headlineCategory.vue'
import PhotoLoader from '@/components/elements/PhotoLoader.vue'
import ModulePlayer from '@/components/modules/ModulePlayer.vue'
import {useUtils} from "@/composables/useUtils";

const props = defineProps({
  context: Object
})
const tag = ref('teraz odtwarzane')
const currentTag = ref(0)

const { getArticleTitle } = useUtils()

const sectionsStore = useSectionsStore()
const { itemsVideoDetails } = storeToRefs(sectionsStore)
const { fetchVideoDetails } = sectionsStore

const headlineTitle = computed(() => props.context?.title ?? 'Wideo')
const showMoreTitle = computed(() => props.context?.show_more)

const videoId = ref()
const showMediaPlayer = ref(false)

const currentVideo = computed(() => itemsVideoDetails.value[videoId.value])

const selectItems = (item, index) => {
  showMediaPlayer.value = false
  if (videoId.value) {
    videoId.value = item._id
    currentTag.value = index
  } else {
    videoId.value = props.context?.items[0]._id
    currentTag.value = 0
  }
  setTimeout(() => {
    showMediaPlayer.value = true
  }, 100)
}

const breakpoints = {
  350: {
    itemsToShow: 2,
    snapAlign: 'start'
  },
  1024: {
    itemsToShow: 3,
    snapAlign: 'start'
  },
  1330: {
    itemsToShow: 4,
    snapAlign: 'start'
  }
}

watch(
  () => videoId.value,
  (value) => {
    fetchVideoDetails(value)
  },
  { immediate: true }
)

onMounted(() => {
  selectItems()
})
</script>

<style lang="scss">
@import '@/assets/scss/components/modules/module-video.scss';
</style>
